module.exports = __webpack_public_path__ + "static/cows-pigs-wars-and-witches-f1e7a2a239b31bd8e75774af4389d404.jpg";